module.exports = __webpack_public_path__ + "static/media/social-media.f7cd7ed4.gif";